module.exports = {"id":"206506","name":"Tristan Dingomé","rating":"71","photo":"./data/images/photos/3/206506.png","club":{"name":"ESTAC Troyes","logo":"./data/images/clubs/ESTACTroyes.png"},"positions":["MDC"],"photoFolderIndex":3}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/TristanDingome0.json
// module id = 4200
// module chunks = 0